export default "__VITE_ASSET__BM9KNAp5__"